import styled from 'styled-components'

export const ColorKey = ({
  entries,
  fromto = false,
}: {
  entries: { label: string; color: string }[]
  fromto?: boolean
}) => {
  return (
    <ColorKeyRoot>
      {entries.map((entry, i) => {
        return (
          <Entry style={{ direction: i === 0 && fromto ? 'rtl' : 'ltr' }}>
            <Swatch
              style={{
                backgroundColor: entry.color,
                marginLeft: i === 0 && fromto ? '10px' : '0',
              }}
            />
            {entry.label}
          </Entry>
        )
      })}
    </ColorKeyRoot>
  )
}

const ColorKeyRoot = styled.div`
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;
  line-height: 1.2em;
  margin-bottom: 30px;
  justify-content: flex-start;
`

const Entry = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-right: 15px;
`

const Swatch = styled.div`
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
`
